import { AllJurisdictionsInfo } from '@commenda/types/src/corporation';
import { fetcher } from '@commenda/utils';
import { useQuery } from '@tanstack/react-query';
import { useApiScope } from '../scope';
import { businessEntityKeys } from './keys';
import { CONTENT_STALE_TIME } from './useSupportedEntities';

const getAllJurisdictions = async (
  shareToken: string | undefined
): Promise<AllJurisdictionsInfo> => {
  const response = await fetcher('business-entities/all/jurisdictions', {
    method: 'GET',
    shareToken,
  });

  if (!response.ok) throw new Error('Failed to load the jurisdictions');

  return (await response.json()) as AllJurisdictionsInfo;
};

export const useAllJurisdictions = () => {
  const { shareToken } = useApiScope();

  return useQuery({
    queryKey: [businessEntityKeys.FETCH_ALL_JURISDICTIONS, shareToken],
    queryFn: () => getAllJurisdictions(shareToken),
    staleTime: CONTENT_STALE_TIME,
  });
};
